import { useTranslate } from '@tolgee/react';
import { Button, Form, InputNumber, message, Modal } from 'antd';
import FormField from 'components/FormField';
import { Formik } from 'formik';
import useModal from 'hooks/useModal';
import { tradeOfferV1 } from 'services/api/return';
import { formatNumber } from 'utils/numberFormat';

function OfferPartialRefund({
  unit,
  max,
  returnSn,
  platform,
  onSuccess,
}: {
  unit: string;
  max: number;
  returnSn: string;
  platform: General.PlatformUpperCase;
  onSuccess: () => void;
}) {
  const { t } = useTranslate();

  const { visible, show, hide } = useModal();

  const button = (
    <Button type="link" onClick={show}>
      {t('部分退款')}
    </Button>
  );

  const modal = (
    <Formik
      initialValues={{ refundAmount: undefined }}
      onSubmit={({ refundAmount }, helpers) => {
        return tradeOfferV1({
          platform,
          returnExternalId: returnSn,
          refundAmount,
        } as any)
          .then(() => {
            onSuccess();
            hide();
            message.success('操作成功');
            helpers.resetForm();
          })
          .catch(() => {
            message.error(t('translation.操作失败，请稍后再试'));
          });
      }}
    >
      {({ isSubmitting, handleSubmit }) => {
        return (
          <Modal
            title={t('部分退款')}
            width={300}
            visible={visible}
            onCancel={hide}
            okText={t('提交部分退款')}
            okButtonProps={{
              loading: isSubmitting,
              onClick: () => handleSubmit(),
            }}
          >
            <Form layout="vertical">
              <FormField
                required
                name="refundAmount"
                label={t('退款金额')}
                extra={
                  <span style={{ color: '#f2a100' }}>
                    {t('trade.最大可退金额', {
                      money: `${unit}${formatNumber(max, '0,0.00')}`,
                    })}
                  </span>
                }
                validate={(value) => {
                  if (!value && value !== 0) {
                    return t('trade.可退金额必填');
                  }
                  if (value > max) {
                    return t('trade.超出最大可退金额');
                  }
                  if (value <= 0) {
                    return t('trade.超出最小可退金额');
                  }
                }}
              >
                {({ field }) => {
                  return (
                    <InputNumber
                      placeholder={t('请输入')}
                      precision={2}
                      addonAfter={unit}
                      {...field}
                    />
                  );
                }}
              </FormField>
            </Form>
          </Modal>
        );
      }}
    </Formik>
  );

  return (
    <>
      {button}
      {modal}
    </>
  );
}

export default OfferPartialRefund;
